import React from "react";

const COLORS = ["orange", "green", "blue", "brown", "black", "gray"];

// Hash the name into a stable color instead of Math.random(), which would
// otherwise reroll on every render and make avatars flicker between colors.
function colorForName(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0;
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}

export default function Avatar({ name, className = "assignee-circ" }) {
  const initials = name.split(" ");

  return (
    <p className={className} title={name} style={{ backgroundColor: colorForName(name) }}>
      {initials[initials.length - 1][0]}
      {initials[0][0]}
    </p>
  );
}
